/**
 * @fileoverview POST handler for the "/open_ai/liquid_assistant" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";

import { openAiLiquidAssistantCacheKeys } from "./constants";
import type { PostOpenAiLiquidAssistantProps, LiquidForGPTAiResponse } from "./types";

export const postOpenAiLiquidAssistant = reactQueryMutationAdapter(
  openAiLiquidAssistantCacheKeys,
  (props: PostOpenAiLiquidAssistantProps): Promise<LiquidForGPTAiResponse> => {
    return fetch("/open_ai/liquid_assistant", "POST", props, undefined, { propagateFetchRequestError: false });
  }
);
